module.exports = __webpack_public_path__ + "static/media/signup_left_side_img.4698abe0.svg";